import React, { useState } from "react";
import { AngleDown, MailIcon } from "../icons";
import { addInquiry } from "../services/btc-api.service";
import { initUserSession } from "../services/auth.service";
import { useMediaQuery } from "react-responsive";

const Form = ({ user, vehicle, button }) => {
  const [inquiry, setInquiry] = useState({});
  const [inquiryDropDown, setInquiryDropDown] = useState(false);

  const handleChange = (e) => {
    setInquiry({ ...inquiry, [e.target.name]: e.target.value });
  };

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const submitForm = async () => {
    await addInquiry({
      ...inquiry,
      userId: user && user._id ? user._id : undefined,
      vehicleId: vehicle._id,
    });

    if (user && user._id) {
      initUserSession();
    }
  };

  return (
    <div className="question-form">
      {!isMobile && (
        <div>
          {!button && <h5>Have Any Question?</h5>}
          <div className="form-box">
            <div className="custom_field">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={inquiry.name}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="custom_field">
              <label>Country</label>
              <input
                type="text"
                name="country"
                value={inquiry.country}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="custom_field">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={inquiry.email}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="custom_field">
              <label>Contact No.</label>
              <input
                type="text"
                name="contactNumber"
                value={inquiry.contactNumber}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="custom_field">
              <label>Details</label>
              <textarea
                name="details"
                value={inquiry.details}
                onChange={(e) => handleChange(e)}
              ></textarea>
            </div>
            <div className="custom_field">
                  <label style={{ opacity: 0 }}>Inquiry</label>
                  <button onClick={() => submitForm()}>
                    <MailIcon />
                    {button ? "Submit" : "Inquiry"}
                  </button>
                </div>
          </div>
        </div>
      )}

      {isMobile && (
        <div className="inquirydropdown">
          <div className="custom_field">
            <span
              style={{ width: "100%" }}
              onClick={() => setInquiryDropDown(!inquiryDropDown)}
            >
              <span style={{paddingLeft:120}}>
                {" "}
                <MailIcon /> Inquiry{" "}
              </span>
              <span style={{paddingLeft:60}}>
                {" "}
                <AngleDown />{" "}
              </span>
            </span>
          </div>
          {inquiryDropDown && (
            <div>
              {!button && <h5>Have Any Question?</h5>}
              <div className="form-box">
                <div className="custom_field">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={inquiry.name}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="custom_field">
                  <label>Country</label>
                  <input
                    type="text"
                    name="country"
                    value={inquiry.country}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="custom_field">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={inquiry.email}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="custom_field">
                  <label>Contact No.</label>
                  <input
                    type="text"
                    name="contactNumber"
                    value={inquiry.contactNumber}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="custom_field">
                  <label>Details</label>
                  <textarea
                    name="details"
                    value={inquiry.details}
                    onChange={(e) => handleChange(e)}
                  ></textarea>
                </div>
                <div className="custom_field">
                  <label style={{ opacity: 0 }}>Inquiry</label>
                  <button onClick={() => submitForm()}>
                    <MailIcon />
                    {button ? "Submit" : "Inquiry"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Form;
